import { Button, Form } from "antd";
import type { FC } from "react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "utils/hooks";
import type { PropsWithFormInstance } from "./types";

interface ISubmitButton extends PropsWithFormInstance {
  buttonName?: string;
  isLoading?: boolean;
  checkIfSubmittable?: boolean;
}
export const SubmitButton: FC<ISubmitButton> = ({
  form,
  isLoading,
  checkIfSubmittable = true,
  buttonName = "commit",
}) => {
  const [isSubmittable, setIsSubmittable] = useState(true);
  const [validateOk, setValidateOk] = useState(true);
  const { t } = useTranslation("button");
  const values = Form.useWatch([], { form, preserve: true });
  const validateForm = useCallback(async () => {
    if (checkIfSubmittable && form) {
      let isSubmittable = false;
      setIsSubmittable(false);
      try {
        await form.validateFields({ validateOnly: true });
        isSubmittable = true;
      } catch (error) {
        const _flag = !(error as any).errorFields.length;
        isSubmittable = _flag;
      } finally {
        setIsSubmittable(isSubmittable);
      }
    }
  }, [checkIfSubmittable, form]);
  useEffect(() => {
    validateForm();
  }, [values, validateForm]);

  return (
    <Button
      type="primary"
      onClick={form?.submit}
      loading={isLoading}
      disabled={!isSubmittable}
    >
      {t(buttonName)}
    </Button>
  );
};
